import { MDXRenderer } from 'gatsby-plugin-mdx';
import React from 'react';

import { MDXProvider } from '@mdx-js/react';
import { IconAccountSettingsNormal, IconFileFileCopy, IconMediaLibraryBooksNormal, IconOperationBookNormal } from '../Icons';

import './ProductSuggestedLibraries.scss';

interface EssentialElementProps {
  title: string;
  link: string;
  type: string;
  children: React.ReactNode;
  openGettingStartedHandler: () => any;
}

export function EssentialElement(props: EssentialElementProps): React.ReactElement {
  const getIcon = (type) => {
    switch (type) {
      case 'getting-started':
        return <IconAccountSettingsNormal />;
      case 'tutorial':
        return <IconFileFileCopy />;
      case 'library':
        return <IconMediaLibraryBooksNormal />;
      case 'resource':
        return <IconOperationBookNormal />;

      default:
        return <IconFileFileCopy />;
    }
  };

  // We have a lot of data in essentials. Until content isn't updated, we have to show only library elements.
  if (props.type !== 'library') return;

  return (
    <div className="product-suggested-libraries__wrapper">
      <a className="product-suggested-libraries__wrapper__title" href={props.link || '#'} rel="noopener noreferrer" target="_blank">
        {getIcon(props.type)}
        {props.title}
        <div className="product-suggested-libraries__wrapper__section">{props.children}</div>
      </a>
    </div>
  );
}

interface EssentialsColumnProps {
  children: React.ReactNode;
  title: string;
}

export function EssentialsColumn(props: EssentialsColumnProps): React.ReactElement {
  // temp if, until the fix the content
  if (props.title === 'First Steps' || props.title === 'Arduino Basics') return;
  return <div className="product-suggested-libraries__grid">{props.children}</div>;
}

interface ProductSuggestedLibrariesProps {
  essentials: {
    body: string;
  };
  product?: string;
  openGettingStartedHandler: () => any;
  children: React.ReactNode;
}

export default function ProductSuggestedLibraries({
  essentials,
  openGettingStartedHandler,
  children,
}: ProductSuggestedLibrariesProps): React.ReactElement {
  return (
    <div className="product-suggested-libraries">
      <MDXProvider
        components={{
          EssentialsColumn,
          EssentialElement: (props) => <EssentialElement {...props} openGettingStartedHandler={openGettingStartedHandler} />,
        }}
      >
        {essentials && <MDXRenderer>{essentials.body}</MDXRenderer>}
      </MDXProvider>
    </div>
  );
}
